import { useState, useEffect } from "react";
import { Button } from "antd";
import { InputOTP } from "antd-input-otp";
import { toast } from "react-toastify";
import { useGoogleLogin, useSetUserDetails } from "./store/store";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { ENV } from "../../config/env";

const InputOTPPage = () => {
  const { setUserDetails } = useSetUserDetails();
  const { loginWithOtp } = useGoogleLogin();
  const [value, setValue] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-fill and auto-submit OTP in dev environment if available
    if (ENV === 'dev') {
      const devOtp = secureLocalStorage.getItem("devOtp");
      if (devOtp && devOtp.length === 6) {
        const otpArray = devOtp.split('');
        setValue(otpArray);
        // Clean up the stored OTP
        secureLocalStorage.removeItem("devOtp");

        // Auto-submit immediately in dev environment
        const email = secureLocalStorage.getItem("otpEmail");
        if (email) {
          const sendPayload = {
            email: email,
            otp: devOtp,
          };
          // Submit immediately without delay
          loginWithOtp(sendPayload, toast, setUserDetails).then((success) => {
            if (!success) {
              // On failure, clear the auto-filled value so user can try again
              setValue([]);
            }
          });
        }
      }
    }
  }, [loginWithOtp, setUserDetails]);
  const handleFinish = async () => {
    const payload = value;
    const email = secureLocalStorage.getItem("otpEmail");
    if (payload?.length == 6) {
      let otpData = payload.join("");
      const sendPayload = {
        email: email,
        otp: otpData,
      };
      const success = await loginWithOtp(sendPayload, toast, setUserDetails);
      if (!success) {
        // On failure, clear the OTP input so user can try again
        setValue([]);
      }
    }
  };

  const handleLoginBack = () => {
    navigate("/login");
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center h-100"
      style={{ height: "100", marginTop: "15%" }}
    >
      <div>
        <div
          className="card p-2 shadow"
          style={{ width: "30rem", height: "20rem" }}
        >
          <h4 className="mx-4 bg-white text-danger p-2 border-bottom border-danger ">
            Please Enter OTP
          </h4>
          <InputOTP
            onChange={setValue}
            value={value}
            // autoSubmit={handleFinish}
          />
          <div className="mx-5 d-flex gap-3 text-center">
            <Button
              className="mt-5 w-50"
              type=""
              onClick={handleLoginBack}
            >
              Back to Login
            </Button>
            <Button className="mt-5 w-50" type="primary" onClick={handleFinish}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputOTPPage;
